import styles from '../pages/General/Burgermenu.module.scss';

const BurgerPfeil = (props) => {
  return (
    <span className={(props.klasse) ? props.klasse +' ' + styles.aufklappbar : styles.aufklappbar}></span>
  )
}

export default BurgerPfeil